import { render, staticRenderFns } from "./EditBuildingForUser.vue?vue&type=template&id=25645ea7&"
import script from "./EditBuildingForUser.vue?vue&type=script&lang=js&"
export * from "./EditBuildingForUser.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports